import React, { useState, useEffect, useRef } from "react";

export const Video = () => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVideoSrc(
            "https://www.youtube.com/embed/Xxv_6aq9Jtw?autoplay=1&mute=1&controls=1&rel=0"
          );
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="mx-auto flex justify-center">
      <div className="relative">
        <div className="absolute -top-[20px] -left-[20px] -right-[20px] -bottom-[20px] z-0 rounded-[40px] before:absolute before:inset-0 before:rounded-[40px] before:bg-gradient-to-br before:from-[#ff69b440] before:via-[#6C3BC750] before:to-[#3498db66] before:opacity-75"></div>
        <div
          ref={videoRef}
          className="relative z-10 rounded-[32px] w-auto md:w-[600px] lg:w-[950px]  max-w-full aspect-video"
        >
          {videoSrc && (
            <iframe
              className="w-full h-full rounded-[32px]"
              src={videoSrc}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
        </div>
      </div>
    </div>
  );
};
